module.exports = __webpack_public_path__ + "img/Union.0907cd36.png";